import {
  FETCH_LEAVE_CATEGORIES_SUCCESS,
  FETCH_LEAVE_CATEGORIE_SUCCESS,
} from '../../constants/ActionTypes'

const initialSettings = {}

export default (state = initialSettings, action) => {
  switch (action.type) {
    case FETCH_LEAVE_CATEGORIES_SUCCESS: {
      return { ...state, index: action.payload }
    }
    case FETCH_LEAVE_CATEGORIE_SUCCESS: {
      return { ...state, show: action.payload }
    }
    default:
      return state
  }
}
